/* === AZN Cart Icon Bubble Sync — Round Y ===
   Garantisce che il badge del carrello (cart-icon-bubble) resti allineato
   con il contenuto del cart dopo ogni POST a /cart/(add|change|update|clear),
   SENZA toccare il <cart-drawer> (gestito da Dawn via renderContents).

   Motivazione: la versione precedente faceva innerHTML replace su
   <cart-drawer>, azzerando i listener e causando drawer "nero" dopo
   quick-add. Ora interveniamo solo sul bubble. */
(function () {
  if (window.__aznCartSyncPatchInstalled) return;
  window.__aznCartSyncPatchInstalled = true;

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function refreshBubble() {
    return fetch('/?sections=cart-icon-bubble', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || !data['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-icon-bubble'];
        var fresh =
          tmp.querySelector('#shopify-section-cart-icon-bubble') || tmp.firstElementChild;
        var cur = document.querySelector('#shopify-section-cart-icon-bubble');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          return;
        }
        var freshBubble = tmp.querySelector('#cart-icon-bubble');
        var curBubble = document.querySelector('#cart-icon-bubble');
        if (freshBubble && curBubble) {
          // Only swap the badge count span to preserve listeners on <a id="cart-icon-bubble">
          var freshCount = freshBubble.querySelector('.cart-count-bubble');
          var curCount = curBubble.querySelector('.cart-count-bubble');
          if (freshCount && curCount) {
            curCount.innerHTML = freshCount.innerHTML;
          } else if (freshCount && !curCount) {
            curBubble.appendChild(freshCount.cloneNode(true));
          } else if (!freshCount && curCount) {
            curCount.remove();
          }
        }
      })
      .catch(function (e) {
        console.warn('[azn-cart-sync] bubble refresh failed:', e);
      });
  }

  // Intercept fetch
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCart = CART_RE.test(url);
    var promise = origFetch(input, init);
    if (isCart) {
      promise
        .then(function (res) {
          if (res && res.ok) setTimeout(refreshBubble, 60);
        })
        .catch(function () {});
    }
    return promise;
  };

  // Intercept XHR
  var OrigXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    var xhr = new OrigXHR();
    var origOpen = xhr.open;
    xhr.open = function (method, url) {
      this.__aznIsCart = CART_RE.test(url || '');
      return origOpen.apply(this, arguments);
    };
    xhr.addEventListener('load', function () {
      if (this.__aznIsCart && this.status >= 200 && this.status < 300) {
        setTimeout(refreshBubble, 60);
      }
    });
    return xhr;
  }
  PatchedXHR.prototype = OrigXHR.prototype;
  window.XMLHttpRequest = PatchedXHR;

  // NO initial refresh on page load — server-render è già corretto, e un
  // refresh prima che <cart-drawer> sia istanziato rompeva i listener.

  console.log('[azn-cart-sync] patch v2 installed (bubble only)');
})();
